import { createFeatureSelector } from '@ngrx/store';
import { pdfDownloadFeatureKey } from '../reducers';
import { PdfDownloadState } from '../reducers/pdf-download.reducer';

export const selectDownloadPdf = createFeatureSelector<PdfDownloadState>(
  pdfDownloadFeatureKey
);
